import { ContractAsyncActions } from 'store/actions/contract';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(ContractAsyncActions));
